/* eslint-disable max-len */

import * as R from 'ramda';
import angular from 'angular';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function EditCRIProfileDialogController(
  $filter,
  $q,
  $rootScope,
  $scope,

  alerts,
  confirmCompleteAssessmentDialog,
  ecatDataService,
  ecatSharedModelService,
  loaderService,

  ssDialogService,
) {
  const vm = this;

  vm.achievementLevels = ecatSharedModelService.achievementLevels;
  vm.maturityLevels = ecatSharedModelService.maturityLevels;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleEditCRIProfileFormSubmit = handleEditCRIProfileFormSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
  }

  /** ***************************************
   * Event Functions
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleEditCRIProfileFormSubmit() {
    if ($scope.ecatEditCRIProfileForm.$valid) {
      loaderService.showViewLoader = true;
      const statements = _getStatementsFromDialog();

      if (statements !== null && statements.length > 0) {
        return ecatDataService.saveBulkCRIAssessment(vm.assessmentId, statements).then(response => {
          if (response.status === 201) {
            alerts.success(copy.advisory.ecat.alerts.saveAssessmentProgressSuccessful.text);
            $rootScope.$broadcast('refreshECATCRIProfile', { assessmentId: vm.assessmentId });

            if (vm.saveType === 'saveAndClose') {
              _closeDialog();
            }
          } else {
            alerts.error(copy.advisory.ecat.alerts.saveAssessmentProgressError.text);
          }

          loaderService.showViewLoader = false;
        });
      } else {
        alerts.success(copy.advisory.ecat.alerts.saveAssessmentProgressSuccessful.text);
        loaderService.showViewLoader = false;

        if (vm.saveType === 'saveAndClose') {
          _closeDialog();
        }
      }
    }
  }

  function _getStatementsFromDialog() {
    const selectedStatements = [];

    R.forEach(function1 => {
      R.forEach(category => {
        R.forEach(subCategory => {
          if (subCategory.criStatements && subCategory.criStatements.length > 0) {
            R.forEach(statement => {
              if (statement.criAssessment) {
                if (!statement.criAssessment.canIncludeInActionPlan) {
                  statement.criAssessment.includeInActionPlan = false;
                }

                selectedStatements.push(statement.criAssessment);
              }
            }, subCategory.criStatements);
          }
        }, category.criSubCategories);
      }, function1.criCategories);
    }, vm.criProfile.functions);

    return selectedStatements;
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.editCRIProfileDialog);
  }
}

EditCRIProfileDialogController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'confirmCompleteAssessmentDialog',
  'ecatDataService',
  'ecatSharedModelService',
  'loaderService',
  'ssDialogService',
];
